import * as React from 'react';
import * as sanitize from 'sanitize-html';

import { Text } from '../Text';

export interface IDescriptionProps {
  description: string;
}

export function Description({ description }: IDescriptionProps) {
  const sanitizeDescription = sanitize(description, {
    allowedTags: ['b', 'i', 'em', 'strong', 'a'],
    allowedAttributes: {
      a: ['href'],
    },
  });

  return (
    <Text textSize="small" color="black">
      {/* eslint-disable-next-line react/no-danger */}
      <span dangerouslySetInnerHTML={{ __html: sanitizeDescription }} />
    </Text>
  );
}
